import type { Branded } from './branded'

type ClientId = Branded<string, 'ClientId'>

const clientId = (value: string): ClientId => value as ClientId

type Client = {
	readonly id: ClientId
	readonly slug: string
	readonly name: string
	readonly site: string
	readonly logo: string
	readonly descr: string
	readonly createdAt: Date
	readonly updatedAt: Date
}

export { clientId }
export type { Client, ClientId }
